import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be0a41f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-summary" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "number" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "number" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "number" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "number" }

import { useRouter } from "vue-router";
import Title from "@/components/MainTitle.vue";
import HelperTools from "@/utils/helper.js";
import Tooltip from "@/components/Tooltip";
import Placement from "@/components/models/Tooltip";
interface Props {
  height: number;
  validator: number;
  tx: number;
  nft: number;
  holder: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    height: null,
    validator: null,
    tx: null,
    nft: null,
    holder: null
  },
  setup(__props: any) {


const routes = ["Blocks", "Txs", "Validators", "Accounts", "ERC-721"];
const router = useRouter();
const navigateTo = (route: string) => {
  router.push({
    name: route,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_t_span = _resolveComponent("t-span")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Title, {
      title: _ctx.$t('home.summary')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo(routes[0])))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("home.height")), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(HelperTools).toFinancialVal(__props.height)), 1)
      ]),
      _createElementVNode("div", {
        class: "item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo(routes[1])))
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("home.txs")), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(HelperTools).toFinancialVal(__props.tx)), 1)
      ]),
      _createElementVNode("div", {
        class: "item",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo(routes[2])))
      }, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("home.validator")), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(__props.validator), 1)
      ]),
      _createVNode(_unref(Tooltip), {
        placement: _unref(Placement).Top
      }, {
        element: _withCtx(() => [
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo(routes[3])))
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("home.accounts")), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(HelperTools).toFinancialVal(__props.holder)), 1)
          ])
        ]),
        tooltip: _withCtx(() => [
          _createVNode(_component_t_span, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("home.accountsdescription")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["placement"]),
      _createElementVNode("div", {
        class: "item",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateTo(routes[4])))
      }, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("home.nfts")), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(HelperTools).toFinancialVal(__props.nft)), 1)
      ])
    ])
  ]))
}
}

})